module.exports = {
      id: "proofread-usage",
      viewBox: "0 0 21.271 15.261",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#proofread",
      toString: function () {
        return this.url;
      }
    }